<nz-layout class="care-team-section">
  <nz-header class="section-header">
    <div fxLayout="row">
      <div fxLayout="col" fxFlex="30">
        {{ "Care Team" | translate }}
      </div>
      <div fxLayout="col" fxFlex="70" fxLayoutAlign="end center">
        @if ((isEOC() || isInpatientView()) && hasPermission(['a-ct'])) {
          <button nz-button nzPrimary
            style="float: right" class="add-care-team-btn" type="button" (click)="handleButton()">
            <i nz-icon nzType="icons:plus" nzTheme="outline"></i>
            {{ "Add Care Team" | translate }}
          </button>
        }
      </div>
    </div>
  </nz-header>
  <nz-content>
    <app-current-care-team />
    <app-care-team-past />
    <app-care-team-add />
  </nz-content>
</nz-layout>
